(function () {
  var ns = (window.SpareParts = window.SpareParts || {});
  ns.instances = ns.instances || {};
  ns.helpers = ns.helpers || {};

  ns.helpers.escapeHtml =
    ns.helpers.escapeHtml ||
    function (value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

  ns.helpers.fetchJson =
    ns.helpers.fetchJson ||
    async function (url, payload) {
      var response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Request failed: ' + response.status);
      }

      return response.json();
    };

  ns.helpers.productUrl =
    ns.helpers.productUrl ||
    function (rawUrl) {
      if (!rawUrl) return '';
      
      if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
      if (rawUrl.charAt(0) === '/') return rawUrl;

      return '/products/' + rawUrl.replace(/^\/+/, '');
    };

function getConfig(sectionId, root) {
  var globalConfig =
    (window.SparePartsConfig && window.SparePartsConfig[sectionId]) || {};

  return {
    sectionId: sectionId,
    apiBase: globalConfig.apiBase || 'https://devapi.madisonb2b.co.uk/api',
    account: globalConfig.account || root.dataset.account || 'L0787',
    brand: globalConfig.brand || root.dataset.brand || '',
    productSku: globalConfig.productSku || root.dataset.sku || '',
    previewSku: globalConfig.previewSku || globalConfig.productSku || root.dataset.sku || ''
  };
}
  function buildShell(root) {
    root.innerHTML = [
      '<div class="spare-parts__docs"></div>',
      '<div class="spare-parts__detail"></div>'
    ].join('');
  }

  function setLoading(target) {
    target.innerHTML = '<div class="spare-parts__loading"></div>';
  }

  function setMessage(target, message) {
    target.innerHTML =
      '<div class="spare-parts__message">' +
      ns.helpers.escapeHtml(message) +
      '</div>';
  }

  function renderDocs(instance, docs) {
    var docsEl = instance.root.querySelector('.spare-parts__docs');
    docsEl.innerHTML = '';

    docs.forEach(function (doc, index) {
      var isWeb = doc.content_type === 'web';
      var element;

      if (isWeb) {
        element = document.createElement('button');
        element.type = 'button';
        element.className = 'spare-parts__doc' + (index === 0 ? ' is-active' : '');
        element.dataset.docNo = doc.doc_no;
        element.innerHTML =
          '<span class="spare-parts__doc-type">EV</span><span>' +
          ns.helpers.escapeHtml(doc.doc_name || doc.doc_no) +
          '</span>';
      } else {
        element = document.createElement('a');
        element.className = 'spare-parts__doc';
        element.href = doc.pdf_file_path;
        element.target = '_blank';
        element.rel = 'noreferrer';
        element.innerHTML =
          '<span class="spare-parts__doc-type">' +
          ns.helpers.escapeHtml(doc.content_type || 'PDF') +
          '</span><span>' +
          ns.helpers.escapeHtml(doc.doc_no) +
          '</span>';
      }

      docsEl.appendChild(element);
    });

    docsEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-doc-no]');
      if (!button) return;

      docsEl.querySelectorAll('.spare-parts__doc').forEach(function (item) {
        item.classList.remove('is-active');
      });

      button.classList.add('is-active');

      var selected = instance.docs.find(function (doc) {
        return doc.doc_no === button.dataset.docNo;
      });

      if (selected && window.SpareParts.loadParts) {
        window.SpareParts.loadParts(instance, selected);
      }
    });
  }

  async function bootRoot(root, options) {
    options = options || {};

    var sectionId = root.dataset.sparePartsRoot;
    if (!sectionId) return;

    if (options.force && ns.instances[sectionId]) {
      delete ns.instances[sectionId];
    }

    if (ns.instances[sectionId]) return;

    var config = getConfig(sectionId, root);
    var instance = {
      sectionId: sectionId,
      root: root,
      config: config,
      docs: []
    };

    ns.instances[sectionId] = instance;
    buildShell(root);

    var detailEl = root.querySelector('.spare-parts__detail');
    setLoading(detailEl);

    try {
      var payload = {
        q: config.productSku || config.previewSku,
        account: config.account
      };

      if (config.brand) {
  payload.brand = config.brand;
}

      var docs = options.docs || await ns.helpers.fetchJson(config.apiBase + '/list', payload);

      if (!Array.isArray(docs) || !docs.length) {
        setMessage(detailEl, 'No spare-parts documents were found for this SKU.');
        return;
      }

      instance.docs = docs;
      renderDocs(instance, docs);

      var firstWebDoc = docs.find(function (doc) {
        return doc.content_type === 'web';
      });

      if (firstWebDoc && window.SpareParts.loadParts) {
        window.SpareParts.loadParts(instance, firstWebDoc);
      } else {
        setMessage(detailEl, 'No interactive exploded-view document was found for this SKU.');
      }
    } catch (error) {
console.error('[SpareParts] list fetch failed', error);
      setMessage(detailEl, 'Spare parts are temporarily unavailable.');
    }
  }

  function bindScrollButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-spare-parts-scroll]');
      if (!button) return;

      var sectionId = button.getAttribute('data-spare-parts-scroll');
      var panel = document.getElementById('spare-parts-' + sectionId);
      if (!panel) return;

      if (panel.tagName === 'DETAILS') {
        panel.open = true;
      }

      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-spare-parts-root]:not([data-saracen-managed])').forEach(bootRoot);
  }
  ns.bootRoot = bootRoot;

  bindScrollButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', bootAll);
})();
